import { createSlice } from '@reduxjs/toolkit';

/**
 *
 * @type FloorStoreState
 */
const initialState = {
  floorList: { loading: false, data: null, error: null }
};

export const FloorSlice = createSlice({
  name: 'floor',
  initialState,
  reducers: {
    fetchFloorListRequest: (state, action) => {
      state.floorList.loading = true;
      state.floorList.error = null;
    },
    fetchFloorListSuccess: (state, action) => {
      state.floorList.data = action.payload;
      state.floorList.loading = false;
      state.floorList.error = null;
    },
    fetchFloorListFailure: (state, action) => {
      state.floorList.data = null;
      state.floorList.loading = false;
      state.floorList.error = action.payload;
    }
  }
});

export const {
  fetchFloorListRequest,
  fetchFloorListSuccess,
  fetchFloorListFailure
} = FloorSlice.actions;

/**
 *
 * @param {*} store
 * @returns {FloorStoreState['floorList']}
 */
export const getFloorListState = (store) => store.floor?.floorList;

export default FloorSlice.reducer;
